import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import DashboardCard, {
  ChartBody,
  ChartPlot,
  ChartTooltip,
  chartTick,
  CHART_MARGIN,
} from '../../dashboard/components/DashboardCard';
import type { AdminDashboardStats } from '../../../domain/superadmin/types';

export function RecurrenceSection({ rows }: { rows: AdminDashboardStats['recurrence'] }) {
  const data = rows.map((r) => ({ name: r.bucket, Ativos: r.active, Inativos: r.inactive }));

  return (
    <section className="mb-s5">
      <DashboardCard title="Distribuição de recorrências">
        <p className="mb-s3 text-[12px] text-muted">
          Quantidade de clientes por tempo de permanência · ativos vs inativos
        </p>
        <ChartBody>
          <ChartPlot>
            <BarChart data={data} margin={CHART_MARGIN}>
              <XAxis dataKey="name" tick={chartTick} tickLine={false} axisLine={false} />
              <YAxis allowDecimals={false} tick={chartTick} tickLine={false} axisLine={false} width={36} />
              <Tooltip content={<ChartTooltip />} />
              <Legend />
              <Bar dataKey="Ativos" stackId="a" fill="var(--color-success)" />
              <Bar dataKey="Inativos" stackId="a" fill="var(--color-error)" />
            </BarChart>
          </ChartPlot>
        </ChartBody>
      </DashboardCard>
    </section>
  );
}
